export const zoneChartData = [
  { week: "Week 21", acceptance: 93, adoption: 87, bar: 8, zone: "GREEN" },
  { week: "Week 22", acceptance: 90, adoption: 93, bar: 18, zone: "GREEN" },
  { week: "Week 23", acceptance: 88, adoption: 88, bar: 20, zone: "GREEN" },
  { week: "Week 24", acceptance: 91, adoption: 91, bar: 20, zone: "GREEN" },
  { week: "Week 25", acceptance: 96, adoption: 96, bar: 20, zone: "GREEN" },
  { week: "Week 26", acceptance: 90, adoption: 90, bar: 20, zone: "MID" },
  { week: "Week 27", acceptance: 89, adoption: 89, bar: 19, zone: "MID" },
  { week: "Week 28", acceptance: 92, adoption: 92, bar: 19, zone: "ALERT" },
  { week: "Week 29", acceptance: 90, adoption: 90, bar: 19, zone: "ALERT" },
  { week: "Week 30", acceptance: 90, adoption: 90, bar: 19, zone: "ALERT" },
  { week: "Week 31", acceptance: 94, adoption: 20, bar: 19, zone: "ALERT" },
  { week: "Week 32", acceptance: 92, adoption: 92, bar: 19, zone: "ALERT" },
  { week: "Week 33", acceptance: 90, adoption: 90, bar: 19, zone: "ALERT" },
  { week: "Week 34", acceptance: 90, adoption: 90, bar: 19, zone: "ALERT" },
  { week: "Week 35", acceptance: 94, adoption: 20, bar: 19, zone: "ALERT" },
  { week: "Week 28", acceptance: 92, adoption: 92, bar: 19, zone: "ALERT" },
  { week: "Week 36", acceptance: 90, adoption: 90, bar: 19, zone: "ALERT" },
  { week: "Week 37", acceptance: 90, adoption: 90, bar: 19, zone: "ALERT" },
  { week: "Week 38", acceptance: 94, adoption: 20, bar: 19, zone: "ALERT" },
  { week: "Week 28", acceptance: 92, adoption: 92, bar: 19, zone: "ALERT" },
  { week: "Week 39", acceptance: 90, adoption: 90, bar: 19, zone: "ALERT" },
  { week: "Week 40", acceptance: 90, adoption: 90, bar: 19, zone: "ALERT" },
  { week: "Week 41", acceptance: 94, adoption: 20, bar: 19, zone: "ALERT" },
  { week: "Week 28", acceptance: 92, adoption: 92, bar: 19, zone: "ALERT" },
  { week: "Week 42", acceptance: 90, adoption: 90, bar: 19, zone: "ALERT" },
  { week: "Week 43", acceptance: 90, adoption: 90, bar: 19, zone: "ALERT" },
  { week: "Week 44", acceptance: 94, adoption: 20, bar: 19, zone: "ALERT" },
];

// MONTHLY DATA
export const monthlyZoneChartData = [
  { week: "Jan", acceptance: 91, adoption: 88, bar: 50, zone: "GREEN" },
   { week: "Apr", acceptance: 93, adoption: 92, bar: 55, zone: "GREEN" },
  { week: "Feb", acceptance: 89, adoption: 90, bar: 45, zone: "MID" },
  { week: "Mar", acceptance: 87, adoption: 85, bar: 40, zone: "ALERT" },
];



export const FGCoverageData = [
  { week: "Week 29", start: 68, end: 100 },
  { week: "Week 30", start: 60, end: 70 },
  { week: "Week 31", start: 59, end: 89 },
  { week: "Week 32", start: 59, end: 69 },
  { week: "Week 33", start: 59, end: 59 },
  { week: "Week 34", start: 59, end: 49 },
  { week: "Week 35", start: 60, end: 51 },
  { week: "Week 36", start: 60, end: 55 },
  { week: "Week 37", start: 60, end: 45 },
  { week: "Week 38", start: 60, end: 65 },
];

export const maiData = [
  { week: "Week 29", start: 68, end: 100 },
  { week: "Week 30", start: 60, end: 70 },
  { week: "Week 31", start: 59, end: 89 },
  { week: "Week 32", start: 59, end: 69 },
  { week: "Week 33", start: 59, end: 59 },
  { week: "Week 34", start: 59, end: 49 },
  { week: "Week 35", start: 60, end: 51 },
  { week: "Week 36", start: 60, end: 55 },
  { week: "Week 37", start: 60, end: 45 },
  { week: "Week 38", start: 60, end: 65 },
];

// Site Adoption Chart Data (flat — one entry per site per week period)
export const siteAdoptionData = [
  // Week 1 — GREEN
  { label: "UPDY", zone: "GREEN", acceptance: 94, adoption: 88, open: 67, accepted: 27, rejected: 34 },
  { label: "U893", zone: "GREEN", acceptance: 90, adoption: 90, open: 72, accepted: 22, rejected: 38 },
  // Week 2 — GREEN
  { label: "UPY",  zone: "GREEN", acceptance: 91, adoption: 89, open: 64, accepted: 44, rejected: 25 },
  { label: "UPDY", zone: "GREEN", acceptance: 92, adoption: 90, open: 60, accepted: 29, rejected: 21 },
  // Week 3 — GREEN
  { label: "U893", zone: "GREEN", acceptance: 93, adoption: 91, open: 74, accepted: 36, rejected: 39 },
  { label: "UPY",  zone: "GREEN", acceptance: 96, adoption: 91, open: 62, accepted: 45, rejected: 20 },
  // Week 4 — GREEN
  { label: "UPDY", zone: "GREEN", acceptance: 94, adoption: 88, open: 70, accepted: 15, rejected: 37 },
  { label: "U893", zone: "GREEN", acceptance: 92, adoption: 90, open: 61, accepted: 28, rejected: 13 },
  // Week 5 — GREEN
  { label: "UPY",  zone: "GREEN", acceptance: 89, adoption: 90, open: 75, accepted: 16, rejected: 26 },
  { label: "UPDY", zone: "GREEN", acceptance: 90, adoption: 95, open: 63, accepted: 30, rejected: 22 },
  // Week 6 — MID
  { label: "U893", zone: "MID",   acceptance: 91, adoption: 93, open: 69, accepted: 18, rejected: 41 },
  { label: "UPY",  zone: "MID",   acceptance: 87, adoption: 94, open: 73, accepted: 31, rejected: 27 },
  // Week 7 — MID
  { label: "UPDY", zone: "MID",   acceptance: 90, adoption: 96, open: 59, accepted: 33, rejected: 20 },
  { label: "U893", zone: "MID",   acceptance: 90, adoption: 90, open: 65, accepted: 19, rejected: 25 },
  // Week 8 — ALERT
  { label: "UPY",  zone: "ALERT", acceptance: 85, adoption: 92, open: 68, accepted: 39, rejected: 22 },
  { label: "UPDY", zone: "ALERT", acceptance: 88, adoption: 91, open: 71, accepted: 18, rejected: 34 },
  // Week 9 — ALERT
  { label: "U893", zone: "ALERT", acceptance: 93, adoption: 90, open: 66, accepted: 12, rejected: 15 },
  { label: "UPY",  zone: "ALERT", acceptance: 96, adoption: 87, open: 60, accepted: 31, rejected: 44 },
  // Week 10 — ALERT
  { label: "UPDY", zone: "ALERT", acceptance: 94, adoption: 89, open: 62, accepted: 22, rejected: 22 },
  { label: "U893", zone: "ALERT", acceptance: 90, adoption: 90, open: 63, accepted: 30, rejected: 41 },
  // Week 11 — ALERT
  { label: "UPY",  zone: "ALERT", acceptance: 92, adoption: 90, open: 75, accepted: 69, rejected: 18 },
  { label: "UPDY", zone: "ALERT", acceptance: 90, adoption: 90, open: 22, accepted: 18, rejected: 27 },
];

// Site Adoption Table Data
const siteAdoptionColumns = siteAdoptionData.map((d) => d.label);

export const siteAdoptionTableData = {
  columns: siteAdoptionColumns,
  rows: [
    {
      label: "Acceptance",
      values: siteAdoptionData.map((d) => d.acceptance + "%"),
      zones: siteAdoptionData.map((d) => d.zone),
    },
    {
      label: "Adoption",
      values: siteAdoptionData.map((d) => d.adoption + "%"),
      zones: siteAdoptionData.map((d) => d.zone),
    },
    {
      label: "Open",
      values: siteAdoptionData.map((d) => d.open),
      zones: siteAdoptionData.map((d) => d.zone),
    },
    {
      label: "Accepted",
      values: siteAdoptionData.map((d) => d.accepted),
      zones: siteAdoptionData.map((d) => d.zone),
    },
    {
      label: "Rejected",
      values: siteAdoptionData.map((d) => d.rejected),
      zones: siteAdoptionData.map((d) => d.zone),
    },
  ],
};